import { inject } from '@angular/core';
import { RedirectFunction, Router } from '@angular/router';
import {
  PAYMENT_RULES_SLUG,
  PAYMENT_RULES_TAB_PARAM,
  type PaymentRulesLayout,
  type PaymentRulesTabId,
} from './payment-rules';

/** Редирект старых адресов оплаты и штрафов на страницу «Оплата и правила» с нужной вкладкой. */
export function paymentRulesRedirect(
  bp: PaymentRulesLayout,
  tab: PaymentRulesTabId,
): RedirectFunction {
  return () =>
    inject(Router).createUrlTree(['/' + bp + '/main/' + PAYMENT_RULES_SLUG], {
      queryParams: { [PAYMENT_RULES_TAB_PARAM]: tab },
    });
}
